import { ProductViewConfigurator } from '~/types/configurator';

let label;
let imageUrl;
let description;

export default {
    controls: [
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [
                {
                    label: (label = 'Clear'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-clear.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'clear',
                    description: (description =
                        'Clear bag allows your product to shine through and meets ASTM D551 standards.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Color options:',
            hideOnProductPage: true,
        },
        {
            key: 'material',
            keyLabel: 'material',
            label: 'Material',
            choices: [
                {
                    label: (label = 'Biodegradable'),
                    detailsModalLabel: label,
                    value: 'biodegradable',
                    description: (description =
                        'This clear, biodegradable material offers impressive clarity, a reliable zipper and meets ASTM D551 standards.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Material options:',
            hideOnProductPage: true,
        },
    ],
} as ProductViewConfigurator;
